import { ConditionalLink } from '../ConditionalLink/ConditionalLink'
import { SoleImage, Soles } from './RelatedSoles.styles'
import type { RelatedSolesProps } from './RelatedSoles.types'

export const RelatedSoles = ({
  soles,
  currentProductHandle,
  className = '',
}: RelatedSolesProps): JSX.Element => {
  return (
    <Soles className={className}>
      {soles.map(({ handle, title, icon }) => {
        return (
          <ConditionalLink
            key={handle}
            href={`/products/${handle}`}
            condition={currentProductHandle !== handle}
            title={title}
          >
            {icon && (
              <SoleImage
                src={icon}
                alt={title}
                selected={currentProductHandle === handle}
              />
            )}
          </ConditionalLink>
        )
      })}
    </Soles>
  )
}
